
<div class="flex">
  <label style="font-weight: 500;">Formulario</label>
  <form [formGroup]="formulario">
    <input id="inputNombreId" type="text" formControlName="nombre" (keyup)="guardaNombre()">
    <!-- <input id="inputNombreId" type="text" formControlName="nombre" (keyup)="guardaNombre()" [ngClass]="formularioValidacionesDocsService.isCampoValidoArrayFormularios(this.indexMostrar, obtenerIndexNifArray()) ? 'errorInput':''"> --> <!--MR 030226 Validaciones de formulario en stand by-->
  </form>
  <svg id="addFormularioId" class="icon-plus" (click)="addFormulario()">
    <use xlink:href="#icon-plus"></use>
  </svg>
  <!-- <svg id="deleteFormularioId" class="icon-delete" (click)="deleteFormulario()">
    <use xlink:href="#hs-bin"></use>
  </svg> -->
</div>
<!-- <p class="texto-validacion" *ngIf="formularioValidacionesDocsService.isCampoValidoArrayFormularios(this.indexMostrar, obtenerIndexNifArray())">
  {{formularioValidacionesDocsService.mensajeErrorNombreFormulario}}
</p> --> <!--MR 030226 Validaciones de formulario en stand by-->
<div class="flex-anadir">
  <div #botonAnadir>
    <app-boton-accion id="btnAnadirId" [icono]="'icon-plus'" [titulo]="'añadir campo'" (botonClicked)="getPosicion($event)"></app-boton-accion>
  </div>
</div>

<app-casillas-temporal *ngFor="let casilla of casillaMoverArray" [posicionCasilla]="posicionCasilla"></app-casillas-temporal>

